import React from "react";
import { colors } from "@toddle-edu/ds-theme";

const IntercomChat = props => {
  const { width, height, fill } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.75 7.5C6.75 6.46165 7.0579 5.44662 7.63478 4.58326C8.21166 3.7199 9.0316 3.047 9.99091 2.64963C10.9502 2.25227 12.0058 2.14831 13.0242 2.35088C14.0426 2.55345 14.9781 3.05347 15.7123 3.78769C16.4465 4.52192 16.9465 5.45738 17.1491 6.47578C17.3517 7.49418 17.2477 8.54978 16.8504 9.50909C16.453 10.4684 15.7801 11.2883 14.9167 11.8652C14.8911 11.8824 14.8653 11.8993 14.8394 11.9159C13.4458 12.812 12 14.0931 12 15.75L12 17.25"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.125 21.375C13.125 21.9963 12.6213 22.5 12 22.5C11.3787 22.5 10.875 21.9963 10.875 21.375C10.875 20.7537 11.3787 20.25 12 20.25C12.6213 20.25 13.125 20.7537 13.125 21.375Z"
        fill={fill}
      />
    </svg>
  );
};

IntercomChat.defaultProps = {
  height: 28,
  width: 24,
  fill: colors.white,
};

export default IntercomChat;
